import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-document-types',
    templateUrl: './document-types.component.html',
    styleUrls: ['./document-types.component.scss'],
    standalone: false
})
export class DocumentTypesComponent {
  @Input() isHidden: boolean;
  @Input() property: string;
  @ViewChild('fileType') fileType: ElementRef;

  get value(): string {
    return this.fileType.nativeElement.innerText;
  }
}
